module.exports = __webpack_public_path__ + "static/media/CTLI_10-444w.b31b3421.jpg";